// Theme: sunset-mainframe
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'sunset-mainframe',
  name: 'SUNSET MAINFRAME',
  tagline: 'SUNSET MAINFRAME',
  description: 'Mainframe retro-futurista em ambar de por do sol.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0A0804', '#1A1408', '#F59E0B', '#FEF9C3'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-sunset-mainframe'
  },
  colorVars: {
    '--accent': '#F59E0B',
    '--accent-foreground': '#0A0804',
    '--background': '#0A0804',
    '--border': '#8A5010',
    '--card': '#1A1408',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEF9C3',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0804',
    '--foreground': '#FEF9C3',
    '--hold-fill': '#F59E0B',
    '--input': '#8A5010',
    '--modal-bg': '#0A0804',
    '--modal-border': '#8A5010',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A5010',
    '--muted-foreground': '#FEF9C3',
    '--nav-active': '#F59E0B',
    '--nav-bg': '#1A1408',
    '--popover': '#1A1408',
    '--popover-foreground': '#FEF9C3',
    '--primary': '#F59E0B',
    '--primary-foreground': '#0A0804',
    '--ring': '#F59E0B',
    '--secondary': '#8A5010',
    '--secondary-foreground': '#FEF9C3',
    '--streak': '#F59E0B',
    '--success': '#22c55e',
    '--success-foreground': '#0A0804',
    '--xp': '#F59E0B',
    '--xp-bg': '#1A1408'
  },
  resolvedVars: {
    '--accent': '#F59E0B',
    '--accent-foreground': '#0A0804',
    '--accent-foreground-hsl': '40 43% 3%',
    '--accent-foreground-oklch': 'from #0A0804 l c h',
    '--accent-hsl': '38 92% 50%',
    '--accent-oklch': 'from #F59E0B l c h',
    '--background': '#0A0804',
    '--background-hsl': '40 43% 3%',
    '--background-oklch': 'from #0A0804 l c h',
    '--border': '#8A5010',
    '--border-hsl': '31 79% 30%',
    '--border-oklch': 'from #8A5010 l c h',
    '--border-w': '1px',
    '--card': '#1A1408',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEF9C3',
    '--card-foreground-hsl': '55 97% 88%',
    '--card-foreground-oklch': 'from #FEF9C3 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '40 53% 7%',
    '--card-oklch': 'from #1A1408 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0804',
    '--destructive-foreground-hsl': '40 43% 3%',
    '--destructive-foreground-oklch': 'from #0A0804 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FEF9C3',
    '--foreground-hsl': '55 97% 88%',
    '--foreground-oklch': 'from #FEF9C3 l c h',
    '--hold-fill': '#F59E0B',
    '--hold-fill-hsl': '38 92% 50%',
    '--hold-fill-oklch': 'from #F59E0B l c h',
    '--input': '#8A5010',
    '--input-hsl': '31 79% 30%',
    '--input-oklch': 'from #8A5010 l c h',
    '--modal-bg': '#0A0804',
    '--modal-bg-hsl': '40 43% 3%',
    '--modal-bg-oklch': 'from #0A0804 l c h',
    '--modal-border': '#8A5010',
    '--modal-border-hsl': '31 79% 30%',
    '--modal-border-oklch': 'from #8A5010 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A5010',
    '--muted-foreground': '#FEF9C3',
    '--muted-foreground-hsl': '55 97% 88%',
    '--muted-foreground-oklch': 'from #FEF9C3 l c h',
    '--muted-hsl': '31 79% 30%',
    '--muted-oklch': 'from #8A5010 l c h',
    '--nav-active': '#F59E0B',
    '--nav-active-hsl': '38 92% 50%',
    '--nav-active-oklch': 'from #F59E0B l c h',
    '--nav-bg': '#1A1408',
    '--nav-bg-hsl': '40 53% 7%',
    '--nav-bg-oklch': 'from #1A1408 l c h',
    '--popover': '#1A1408',
    '--popover-foreground': '#FEF9C3',
    '--popover-foreground-hsl': '55 97% 88%',
    '--popover-foreground-oklch': 'from #FEF9C3 l c h',
    '--popover-hsl': '40 53% 7%',
    '--popover-oklch': 'from #1A1408 l c h',
    '--primary': '#F59E0B',
    '--primary-foreground': '#0A0804',
    '--primary-foreground-hsl': '40 43% 3%',
    '--primary-foreground-oklch': 'from #0A0804 l c h',
    '--primary-hsl': '38 92% 50%',
    '--primary-oklch': 'from #F59E0B l c h',
    '--radius': '12px',
    '--ring': '#F59E0B',
    '--ring-hsl': '38 92% 50%',
    '--ring-oklch': 'from #F59E0B l c h',
    '--secondary': '#8A5010',
    '--secondary-foreground': '#FEF9C3',
    '--secondary-foreground-hsl': '55 97% 88%',
    '--secondary-foreground-oklch': 'from #FEF9C3 l c h',
    '--secondary-hsl': '31 79% 30%',
    '--secondary-oklch': 'from #8A5010 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#F59E0B',
    '--streak-hsl': '38 92% 50%',
    '--streak-oklch': 'from #F59E0B l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0804',
    '--success-foreground-hsl': '40 43% 3%',
    '--success-foreground-oklch': 'from #0A0804 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(38 92% 50% / 0.15)',
    '--xp': '#F59E0B',
    '--xp-bg': '#1A1408',
    '--xp-bg-hsl': '40 53% 7%',
    '--xp-bg-oklch': 'from #1A1408 l c h',
    '--xp-hsl': '38 92% 50%',
    '--xp-oklch': 'from #F59E0B l c h'
  }
}
